<div class="section-menu-items py-3">
  <button
    mat-flat-button
    class="item-each"
    [routerLink]="['rewards']"
    routerLinkActive="router-link-active"
  >
    <span translate class="translate"> pages.newRetailer.rewardsConfiguration</span>
    <mat-icon class="ms-2">confirmation_number</mat-icon>
  </button>
  <button
    mat-flat-button
    class="item-each"
    [routerLink]="['promocodes']"
    routerLinkActive="router-link-active"
  >
    <span translate class="translate"> pages.newRetailer.promocodesConfiguration</span>
    <mat-icon class="ms-2">loyalty</mat-icon>
  </button>
</div>
<router-outlet></router-outlet>
